import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { PackCodes as PackCodesBase } from "./PackCodes";

export type * from "./PackCodes";
export const PackCodes = withLoyaltyStore(PackCodesBase, "PackCodes");
